export const packNumericIds = (ids: number[]) => ids.join(',');

export const unpackNumericIds = (ids: string) => ids.split(',').map(Number);
